// test2873
(2873 && 0);
